module.exports = __webpack_public_path__ + "img/energy.0b2bd4fc.png";